import { IconVolumeFill, IconVolumeMutedFill } from 'assets/svg/sprite'

interface StoryMuteProps {
    handleMute: () => void
    isMuted: boolean
}

export function StoryMute({ handleMute, isMuted }: StoryMuteProps) {
    return (
        <div onClick={handleMute}>
            {isMuted ? (
                <IconVolumeMutedFill />
            ) : (
                <IconVolumeFill color='#FFFFFF' />
            )}
        </div>
    )
}

export default StoryMute
